function listWishlist() {
    document.querySelectorAll('.add-to-wishlist').forEach(button => {
        if (button.dataset.productHandle) {
            const handle = button.dataset.productHandle;
            const title = button.dataset.productTitle;
            let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
            const index = wishlist.findIndex(p => p.handle === handle);
            if (index === -1) {

            } else {
                button.classList.add('wishlist_active');
            }
        }
    });
}
listWishlist()

//QUICK ADD DOM UPDATE - WISHLIST
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        document.querySelectorAll('.quick-add-cs-btn').forEach(button => {
            button.addEventListener('click', () => {
                setTimeout(function () {
                    listWishlist()
                },500)
            })
        })
    },2000)
});
document.addEventListener('click', function (e) {
    const button = e.target.closest('.add-to-wishlist');
    if (!button) return;
    const trans = getTranslationOfWishlist()
    const handle = button.dataset.productHandle;
    const title = button.dataset.productTitle;
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    const index = wishlist.findIndex(p => p.handle === handle);

    if (index === -1) {
        wishlist.push({ handle, title });
        showToast(`${title} ${trans.added}`, 'success',"/pages/wishlist", trans.visitWishlist);
        button.classList.add('wishlist_active');
    } else {
        wishlist.splice(index, 1);
        showToast(`${trans.removed1} ${title} ${trans.removed2}`, 'error',"/pages/wishlist",trans.visitWishlist);
        button.classList.remove('wishlist_active');
    }

    localStorage.setItem('wishlist', JSON.stringify(wishlist));
});

if(document.getElementById('wishlist-page') || document.getElementById('cart-page')){
    document.addEventListener("DOMContentLoaded", async function () {
        const wishlist = (JSON.parse(localStorage.getItem("wishlist")) || []).reverse();
        const listContainer = document.getElementById("wishlist-items");
        let mainContent = "";
        const trans = getTranslationOfWishlist()
        if (wishlist.length === 0) {
            listContainer.innerHTML = `<div class="text-center" id="empty-wishlist">${trans.emptyList}</div>`;
        } else {
            console.warn("listContainer")
            listContainer.innerHTML = Array(wishlist.length).fill().map(() => {
                return `
                <div class="f-column">
                  <div class="product-card skeleton-card">
                    <div class="product-card__image-wrapper skeleton-image shimmer"></div>
                    <div class="product-card__info">
                      <div class="skeleton-line skeleton-title shimmer"></div>
                      <div class="skeleton-line skeleton-price shimmer"></div>
                      <div class="skeleton-line skeleton-button shimmer"></div>
                    </div>
                  </div>
                </div>
              `;
                        }).join('');
            let isWishlistPage = document.getElementById('wishlist-page');
            const limitedWishlist = isWishlistPage ? wishlist : wishlist.slice(0, 8);
            for (const item of limitedWishlist) {
                try {
                    const res = await fetch(`/products/${item.handle}.js`);
                    const product = await res.json();
                    let title = product.title;
                    let handle = product.handle;
                    let url = product.url;
                    let featured_image = product.featured_image;
                    mainContent += `
                        <div class="f-column" style="transform: translateY(0px); opacity: 1; visibility: visible;">
                            <div class="product-card  product-card-style-card color-scheme-1 mobile-hide-quick-add">
                                <div class="product-card__wrapper h-full product-card__wrapper--badge-hidden">
                                    <button class="btn btn--inherit add-to-wishlist wishlist_active show-wishlist-always" data-product-handle="${handle}" data-product-title="${title}">
                                        <span class="favorite">
                                        <!--?xml version="1.0" encoding="UTF-8"?-->
                                        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                            <defs>
                                                <style>
                                                    .cls-1 {
                                                        fill: #242424;
                                                    }
                                                </style>
                                            </defs>
                                            <path class="cls-1" d="M22.14,3.45c2.71,0,5.06,1.93,5.69,4.45l.16,1.79c.01.17.2,4.19-4.49,8.8-2.25,2.26-4.8,4.45-8.5,7.48-3.67-3-6.21-5.18-8.52-7.5C1.79,13.88,1.98,9.86,1.99,9.72v-.09s0-.09,0-.09v-.31c0-3.13,2.68-5.78,5.86-5.78,2.53,0,4.5,1.76,5.33,3.5l.79,1.66c.41.85,1.62.85,2.03,0l.79-1.66c.83-1.74,2.8-3.5,5.33-3.5M22.14,1.45c-3.17,0-5.9,2.04-7.14,4.64-1.24-2.6-3.97-4.64-7.14-4.64C3.52,1.45,0,5.06,0,9.23v.31s-.44,4.95,5.07,10.36c2.51,2.51,5.31,4.9,9.92,8.65,4.61-3.75,7.42-6.14,9.92-8.65,5.51-5.41,5.07-10.36,5.07-10.36h.01v-.31c0-4.17-3.52-7.78-7.85-7.78h0Z"></path>
                                        </svg>
                                        </span>
                                        <span class="favorited"><!--?xml version="1.0" encoding="UTF-8"?-->
                                            <svg id="favorited-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                                <defs>
                                                    <style>
                                                        .cls-1 {
                                                            fill: #a60f00;
                                                        }
                                                    </style>
                                                </defs>
                                                <path class="cls-1" d="M29.99,9.54h0c0-.1,0-.21,0-.31,0-4.17-3.52-7.78-7.85-7.78-3.17,0-5.9,2.04-7.14,4.64h0c-1.24-2.6-3.97-4.64-7.14-4.64C3.52,1.45,0,5.06,0,9.23c0,.1,0,.21,0,.31h0s-.44,4.95,5.07,10.36c2.51,2.51,5.31,4.9,9.92,8.65,4.61-3.75,7.42-6.14,9.92-8.65,5.51-5.41,5.07-10.36,5.07-10.36Z"></path>
                                            </svg>
                                        </span>
                                    </button>
                                    <div class="product-card__image-wrapper product-card__image-wrapper--main-only color-scheme-1 bg-none">
                                        <a href="${url}" tabindex="-1" aria-label="Formula Pro Advanced WiFi Baby Formula Dispenser">
                                            <motion-element data-motion="stagger" class="block">
                                                <div class="media-wrapper product-card__image product-card__image--main loaded" style="--aspect-ratio: 1.0">
                                                    <img src="${featured_image}" alt="${title}" width="300" height="300" loading="lazy" fetchpriority="low" class="motion-reduce loaded" sizes="(max-width: 767px) calc((100vw - 30px) / 1),
                                                    (max-width: 1023px) calc((100vw - 30px) / 3),
                                                    352px" is="image-lazy">
                                                </div>    
                                            </motion-element>
                                        </a>
                                    </div>
                                    <div class="product-card__info text-left">
                                        <h3 class="product-card__title text-pcard-title">
                                            <a class="reversed-link" href="${url}">${title}</a>
                                        </h3>
                                        <div class="product-card__price-and-buy-now-button-wrapper">
                                            <div class="product-card__buy-now-button">
                                                <a href="${url}" class="btn btn--secondary-blue">
                                                    <span>${trans.buyNow}</span>
                                                </a>
                                            </div>
                                        </div>      
                                    </div>
                                 </div>
                            </div>
                        </div>
                        `
                }catch (e){
                    console.log(`${e}`);
                }
            }
            listContainer.innerHTML = mainContent;
        }
    });
}
function getTranslationOfWishlist() {
    const translationsEl = document.getElementById('translations');
    const buyNow = translationsEl.dataset.buyNow;
    const emptyList = translationsEl.dataset.emptyList;
    const added = translationsEl.dataset.added;
    const removed1 = translationsEl.dataset.removed1;
    const removed2 = translationsEl.dataset.removed2;
    const visitWishlist = translationsEl.dataset.visitWishlist;
    return {
        buyNow, emptyList,added, removed1,removed2, visitWishlist
    }
}

